// src/pages/XenoarcPage.jsx
import React from "react";
import LearnMoreLayout from "./components/ui/LearnMoreLayout";

export default function XenoarcPage() {
  const sections = [
    {
      id: "what-is-xenoarc",
      title: "What Xenoarc is",
      navLabel: "What is Xenoarc",
      content: (
        <p className="text-[#585F72]">
          Xenoarc is a step-based range-trading bot that automates a simple
          idea: buy on dips, take profit on bounces. It works around the current
          market price and breaks price movement into steps so it can work
          volatility for you, day and night.
        </p>
      ),
    },
    {
      id: "how-it-trades",
      title: "How It Trades (High Level)",
      navLabel: "How It Trades (High Level)",
      content: (
        <ul className="list-disc pl-5 space-y-2 text-[#585F72]">
          <li>
            Starts from the current market price and builds a series of trading
            steps around it.
          </li>
          <li>
            Buys gradually as price moves into more attractive zones, instead of
            going all-in at once.
          </li>
          <li>Takes profit in stages as price moves back in your favour.</li>
          <li>
            Adjusts its working zone over time so it can keep trading even when
            the market trends away from the starting point.
          </li>
          <li>
            Uses internal confirmation logic to avoid reacting to every tiny
            price wiggle, focusing instead on more meaningful moves.
          </li>
          <li>
            Can scale its position size after strong moves so that big swings
            have a bigger impact on your overall results.
          </li>
        </ul>
      ),
    },
    {
      id: "why-different",
      title: "Why It’s Different?",
      navLabel: "Why It’s Different",
      content: (
        <ul className="list-disc pl-5 space-y-2 text-[#585F72]">
          <li>
            <span className="font-bold">
              No fixed top/bottom range to guess
            </span>{" "}
            – you don&apos;t need to predict exact extremes.
          </li>
          <li>
            <span className="font-bold">Capital-aware engine</span> – your
            capital and trade size define how many steps the bot can support.
          </li>
          <li>
            <span className="font-bold">
              Works with volatility instead of fighting it
            </span>{" "}
            – designed for markets that move in waves.
          </li>
          <li>
            <span className="font-bold">
              Built for both beginners and advanced users
            </span>{" "}
            – start with presets, then customise when you&apos;re ready.
          </li>
        </ul>
      ),
    },
    {
      id: "key-benefits",
      title: "Key Benefits for Users",
      navLabel: "Key Benefits for Users",
      content: (
        <ul className="list-disc pl-5 space-y-2 text-[#585F72]">
          <li>
            Automates a disciplined &quot;buy lower, exit higher&quot; approach.
          </li>
          <li>
            Helps smooth out entries and exits instead of chasing a single
            perfect price.
          </li>
          <li>Reduces emotional decision-making by following clear rules.</li>
          <li>
            Lets you stay active in the market without staring at charts all
            day.
          </li>
        </ul>
      ),
    },
  ];

  return (
    <LearnMoreLayout
      title="Xenoarc"
      breadcrumb={[
        { label: "Home", onClick: () => (window.location.href = "/") },
        { label: "Xenoarc" },
      ]}
      sections={sections}
    />
  );
}
